import _ from 'lodash'

export const debounceSearch = (callback: (...args: any[]) => void, delay = 500) => {
    return _.debounce(callback, delay)
}
